import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  header: {
    padding: '1rem 1.5rem 0.25rem',
    display: 'flex',
    gap: '1rem',
    justifyContent: 'space-between',
    color: neutral[100],
    backgroundColor: neutral.white,
    '& > div': {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '1rem',
    },
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: '2rem',
    letterSpacing: -0.015,
  },
  icon: {
    padding: '0.5rem',
    fontSize: '2.5rem',
    cursor: 'pointer',
  },
});
